document.addEventListener('DOMContentLoaded', function () {

  function switchFrameImage(frameValue) {

    const thumbnails = document.querySelectorAll(
      '.thumbnail-list .thumbnail'
    );

    if (!thumbnails.length) return;

    let targetIndex = 0;

    const value = frameValue.toLowerCase();

    if (value.includes('wrapped')) {
      targetIndex = 0;
    } else if (value.includes('black')) {
      targetIndex = 1;
    } else if (value.includes('gold')) {
      targetIndex = 2;
    }

    if (thumbnails[targetIndex]) {
      thumbnails[targetIndex].click();
    }
  }

  document.addEventListener('change', function (event) {

    if (
      event.target.matches(
        '.frame-picker input[type="radio"]'
      )
    ) {
      switchFrameImage(event.target.value);
    }

  });

});